import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";

const VariablesPorContrato = (props) => {
  const [list1, setList1] = useState([]);
  const urlendpoint =
    "https://contratosback-dev.azurewebsites.net/api/v1/ObtieneContratosVariables/" +
    props.idContrato;
  useEffect(() => {
    const fetchData = () => {
      axios({
        auth: {
          username: "admin.icontec@icontec.org",
          password: "quAngEraMuSTerGerEDE",
        },
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        method: "get",
        url: urlendpoint,
      })
        .then((response) => {
          setList1(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    // Llama a fetchData inicialmente
    fetchData();

    // Configura un intervalo para llamar a fetchData cada 2 segundos
    const intervalId = setInterval(fetchData, 2000);

    // Limpia el intervalo cuando el componente se desmonta o cuando setList1 cambia
    return () => clearInterval(intervalId);
  }, [setList1]);

  return (
    <>
      {/* Page content */}
      <br />
      <br /> <br /> <br /> <h3 className="mb-0">VARIABLES DILIGENCIADAS</h3>
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <br></br> <br></br> <br></br> <br></br>
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Soportes</h3>
              </CardHeader>
              <div className="text-center"></div>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Variable</th>
                    <th scope="col">Contenido</th>
                  </tr>
                </thead>
                <tbody>
                  {list1.map((item) => {
                    return (
                      <tr>
                        <td>{item.id}</td>
                        <td>{item.variable}</td>
                        <td>{item.contenidoVariable}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem className="disabled">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2 <span className="sr-only">(current)</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
      </Container>
    </>
  );
};

export default VariablesPorContrato;
